export const LOAD_ZONES_QUERY = require('../../../../../../Common/js/components/graphql/queries/loadZonesQuery.graphql');
export const LOAD_INDUSTRIES_QUERY = require('../../../Offer/graphql/queries/loadIndustriesQuery.graphql');
export const LOAD_MY_CLASSIFIED_ADS_CATEGORIES = require('./loadMyClassifiedAdsCategories.graphql');
